/** @format */

//-Start Math-------------------------------------------------------------------------------------------------------
const svgTools = () => {
    const segmentAngle = (startPoint, endPoint) => {
        let x = endPoint.x - startPoint.x;
        let y = endPoint.y - startPoint.y;

        if (y === 0) {
            if (x < 0) return 270;
            if (x > 0) return 90;
        }

        if (x === 0) {
            if (y < 0) return 0;
            if (y > 0) return 180;
        }

        let theta = Math.atan2(y, x); // range (-PI, PI)
        theta *= 180 / Math.PI; // rads to degs, range (-180, 180)
        //if (theta < 0) theta = 360 + theta; // range (0, 360)
        return theta;
    };

    const segmentLength = (startPoint, endPoint) => {
        return Math.hypot(startPoint.x - endPoint.x, startPoint.y - endPoint.y);
    };

    function Segment(startPoint, endPoint) {
        this.dx = endPoint.x - startPoint.x;
        this.dy = endPoint.y - startPoint.y;
        this.rdx = startPoint.x - endPoint.x;
        this.rdy = startPoint.y - endPoint.y;
        this.startPoint = startPoint;
        this.endPoint = endPoint;
        this.length = segmentLength(startPoint, endPoint);
        this.deg = segmentAngle(startPoint, endPoint);
        this.rdeg = segmentAngle(endPoint, startPoint);
        this.rad = (this.deg / 180) * Math.PI;
        this.rrad = (this.deg / 180) * Math.PI;
        this.normalizedX = this.dx / this.length;
        this.normalizedY = this.dy / this.length;
        this.perpendicular = {x: -this.normalizedY, y: this.normalizedX};
        this.rPerpendicular = {x: -(this.rdy / this.length), y: this.rdx / this.length};
    }

    const profilePath = coords => {
        let segments = [];

        for (let i = 0; i < coords.length; i++) {
            let seg;

            if (i !== coords.length - 1) {
                seg = new Segment(coords[i], coords[i + 1]);
            } else {
                seg = new Segment(coords[i], coords[0]);
            }

            segments.push(seg);
        }

        return segments;
    };

    const insetPoint = (segment, distance) => {
        let dist = distance * 1;
        let y = segment.startPoint.y + dist * segment.perpendicular.y;
        let x = segment.startPoint.x + dist * segment.perpendicular.x;
        return {x: x, y: y};
    };

    const insetReversePoint = (segment, distance) => {
        let y = segment.endPoint.y + distance * segment.rPerpendicular.y;
        let x = segment.endPoint.x + distance * segment.rPerpendicular.x;
        return {x: x, y: y};
    };

    const offsetPoint = (segment, distance) => {
        let dist = distance * 1;
        let y = segment.startPoint.y + dist * segment.perpendicular.y;
        let x = segment.startPoint.x + dist * segment.perpendicular.x;
        return {x: x, y: y};
    };

    const offsetReversePoint = (segment, distance) => {
        let y = segment.endPoint.y + distance * segment.rPerpendicular.y;
        let x = segment.endPoint.x + distance * segment.rPerpendicular.x;
        return {x: x, y: y};
    };

    const innerBorder = (profile, bleed) => {
        let outline = [];

        // inner perimeter
        profile.forEach(segment => {
            outline.push(insetPoint(segment, -bleed));
            outline.push(insetReversePoint(segment, bleed));
        });

        return outline;
    };

    const outerBorder = (profile, bleed) => {
        let outline = [];

        // outer perimeter
        profile.forEach(segment => {
            outline.push(offsetPoint(segment, -bleed));
            outline.push(offsetReversePoint(segment, bleed));
        });

        return outline;
    };

    const getAngle = segment => {
        console.log('segment: ', segment);
    };

    //-End Math---------------------------------------------------------------------------------------------------------

    const objPathToArray = path => {
        let lastPoint = {x: 0, y: 0};
        let newPath = [];

        for (let i = 0; i < path.length; i++) {
            let pointArray = [];
            let point = path[i];
            let newPoint = point;

            newPoint.x = newPoint.x ?? lastPoint.x;
            newPoint.y = newPoint.y ?? lastPoint.y;

            if (point?.relative) {
                newPoint.x += lastPoint.x;
                newPoint.y += lastPoint.y;

                if (point?.curve) {
                    // pointArray[0] = point.curve.control + lastPoint.x;
                    // pointArray[1] = point.curve.end + lastPoint.y;
                    if (point?.curve?.type === 'quadratic') {
                        newPoint.x = point.curve.control + lastPoint.x;
                        newPoint.y = point.curve.end + lastPoint.y;
                        pointArray = [newPoint.x, newPoint.y];
                    }

                    if (point?.curve?.type === 'cubic') {
                        pointArray.push(
                            point?.curve?.control_start?.x,
                            point?.curve?.control_start?.y
                        );
                        pointArray.push(point?.curve?.control_end?.x, point?.curve?.control_end?.y);
                    }
                    // pointArray.push(point.curve.control + path[i].x);
                    // pointArray.push(point.curve.end + path[i].y);
                } else {
                    pointArray.push(newPoint.x, newPoint.y);
                }
            } else {
                pointArray = [newPoint.x, newPoint.y];

                if (point?.curve) {
                    if (point?.curve?.type === 'quadratic') {
                        pointArray[0] = point.curve.control + lastPoint.x;
                        pointArray[1] = point.curve.end + lastPoint.y;
                    }
                    if (point?.curve?.type === 'cubic') {
                        pointArray[0] = point.curve.control + lastPoint.x;
                        pointArray[1] = point.curve.end + lastPoint.y;
                    }
                    // pointArray.push(point.curve.control);
                    // pointArray.push(point.curve.end);
                }
            }

            lastPoint = newPoint;
            newPath.push(pointArray);
        }

        return newPath;
    };

    // build an SVG path out of basic coordinates array - works with quadratic curves as 3rd and 4th coordinates
    const buildPath = coords => {
        let path = 'M ';
        let segments = [];

        coords.forEach((point, index) => {
            let segment;
            if (point.length > 2) {
                segment = point.shift() + ' ' + point.shift() + ' Q ' + point.join(' ');
            } else {
                segment = point.join(' ');

                if (index !== coords.length - 1) {
                    segment = segment + ' L ';
                }
            }
            segments.push(segment);
        });

        const suffix = coords.length > 2 ? ' z' : '';

        return path + segments.join(' ') + suffix;
    };

    // build an SVG path out of object based array - works with quadratic curves as child object
    const buildPathFromObj = coords => {
        let segments = [];

        coords.forEach((point, index) => {
            let type = 'L';

            if (index === 0) {
                type = 'M';
            }

            if (point.hasOwnProperty('x') && !point.hasOwnProperty('y')) {
                type = 'H';
            }

            if (point.hasOwnProperty('y') && !point.hasOwnProperty('x')) {
                type = 'V';
            }

            if (point?.curve) {
                if (point?.curve?.type.toLowerCase() === 'quadratic') {
                    if (point?.curve?.hasOwnProperty('control_end')) {
                        type = 'Q';
                    } else {
                        type = 'T';
                    }
                }
                if (point?.curve?.type.toLowerCase() === 'cubic') {
                    if (point?.curve?.hasOwnProperty('control_start')) {
                        type = 'C';
                    } else {
                        type = 'S';
                    }
                }
            }

            if (point?.relative) type = type.toLowerCase();

            segments.push(type);

            if (point?.curve) {
                if (point?.curve?.hasOwnProperty('control_start')) {
                    segments.push(point.curve.control_start.x.toFixed(4));
                    segments.push(point.curve.control_start.y.toFixed(4));
                }
                if (point?.curve?.hasOwnProperty('control_end')) {
                    segments.push(point.curve.control_end.x.toFixed(4));
                    segments.push(point.curve.control_end.y.toFixed(4));
                }
            }

            // segment += point.x + ' ' + point.y;
            if (point.hasOwnProperty('x')) segments.push(point.x.toFixed(4));
            if (point.hasOwnProperty('y')) segments.push(point.y.toFixed(4));
        });

        const suffix = coords.length > 2 ? ' z' : '';

        return segments.join(' ') + suffix;
    };

    // engine may require first coordinate repeated at end, this does that
    const repeatFirst = coords => {
        return [...coords, coords[0]];
    };

    // convert svg notation to obj
    // scale may be 72 due to dpi of illustrator
    const pathToObj = (path, scale, offsetX, offsetY) => {
        let obj = [];
        let divisor = scale ?? 1;
        let points = path.split(/(?=[A-Za-z])/g);

        // TODO needed to convert paths, but causing problems in production. Uncomment before use
        // points.forEach((point, index) => {
        //     //point = point.replace(/(?<=[A-Za-z])/g, ' ');
        //     point = point.replace(/-/g, ' -');
        //     point = point.replace(/,/g, ' ');
        //     point = point.replace(/\s+/g, ' ').trim();
        //     point = point.split(' ');
        //     points[index] = point;
        // })

        points.forEach(point => {
            if (point[0].toLowerCase() === 'z') return;
            let pointObj = {
                type: point[0]
            };

            let isRelative = point[0] === point[0].toLowerCase();
            pointObj.relative = isRelative;

            switch (point[0].toLowerCase()) {
                case 'v':
                    pointObj.y = point[1] / divisor;
                    break;
                case 'h':
                    pointObj.x = point[1] / divisor;
                    break;
                case 't':
                    pointObj.curve = {};
                    pointObj.curve.type = 'quadratic';
                    pointObj.curve.control_end = {};
                    break;
                case 'q':
                    pointObj.curve = {};
                    pointObj.curve.type = 'quadratic';

                    pointObj.curve.control_end = {};
                    pointObj.curve.control_end.x = point[1] / divisor;
                    pointObj.curve.control_end.y = point[2] / divisor;

                    pointObj.x = point[point.length - 2] / divisor;
                    pointObj.y = point[point.length - 1] / divisor;
                    break;
                case 's':
                    pointObj.curve = {};
                    pointObj.curve.type = 'cubic';

                    pointObj.curve.control_end = {};
                    pointObj.curve.control_end.x = point[1] / divisor;
                    pointObj.curve.control_end.y = point[2] / divisor;

                    pointObj.x = point[point.length - 2] / divisor;
                    pointObj.y = point[point.length - 1] / divisor;
                    break;
                case 'c':
                    pointObj.curve = {};
                    pointObj.curve.type = 'cubic';

                    pointObj.curve.control_start = {};
                    pointObj.curve.control_start.x = point[1] / divisor;
                    pointObj.curve.control_start.y = point[2] / divisor;

                    pointObj.curve.control_end = {};
                    pointObj.curve.control_end.x = point[3] / divisor;
                    pointObj.curve.control_end.y = point[4] / divisor;

                case 'm':
                case 'l':
                    pointObj.x = point[point.length - 2] / divisor;
                    pointObj.y = point[point.length - 1] / divisor;
                    break;
            }

            if (!isRelative) {
                if (pointObj.hasOwnProperty('x')) pointObj.x += offsetX;
                if (pointObj.hasOwnProperty('y')) pointObj.y += offsetY;

                if (pointObj.hasOwnProperty('curve')) {
                    pointObj.curve.control_end.x += offsetX;
                    if (pointObj.curve.hasOwnProperty('control_start')) {
                        pointObj.curve.control_start.x += offsetX;
                    }
                }
            }

            obj.push(pointObj);
        });

        return obj;
    };

    // converts any relative points in a path to absolute
    const makePathAbsolute = path => {
        let lastPoint = {x: 0.0, y: 0.0};

        return path.map(point => {
            let newPoint = point;

            if (point?.relative) {
                newPoint.relative = false;
                newPoint.type = newPoint?.type?.toUpperCase();

                if (newPoint.hasOwnProperty('x') && typeof newPoint.x === 'number') {
                    newPoint.x += lastPoint.x ?? 0;
                } else {
                    newPoint.x = lastPoint.x;
                }
                if (newPoint.hasOwnProperty('y') && typeof newPoint.y === 'number') {
                    newPoint.y = newPoint?.y + lastPoint.y ?? 0;
                } else {
                    newPoint.y = lastPoint.y;
                }

                if (newPoint.hasOwnProperty('curve')) {
                    if (newPoint.curve.hasOwnProperty('control_start')) {
                        newPoint.curve.control_start.x += lastPoint.x;
                        newPoint.curve.control_start.y += lastPoint.y;
                    }
                    if (newPoint.curve.hasOwnProperty('control_end')) {
                        newPoint.curve.control_end.x += lastPoint.x;
                        newPoint.curve.control_end.y += lastPoint.y;
                    }
                }
            } else {
                if (!newPoint.hasOwnProperty('x') || typeof newPoint.x != 'number') {
                    newPoint.x = lastPoint.x;
                }
                if (!newPoint.hasOwnProperty('y') || typeof newPoint.y != 'number') {
                    newPoint.y = lastPoint.y;
                }
            }

            lastPoint = newPoint;
            return newPoint;
        });
    };

    // searches through two paths and finds the node from the second path that is closest to the first node in the first path
    const findClosestNode = (path1, path2) => {
        let closestNode = {
            index: 0,
            node: null,
            xDiff: null,
            yDiff: null,
            diff: null
        };

        path2.forEach((node, index) => {
            let xDiff = Math.abs(path1[0].x - node?.x);
            let yDiff = Math.abs(path1[0].y - node?.y);

            let currentNode = {
                index: index,
                node: node,
                xDiff: xDiff,
                yDiff: yDiff,
                diff: xDiff + yDiff
            };

            if (index === 0 || currentNode.diff < closestNode.diff) {
                closestNode = currentNode;
            }
        });

        return closestNode;
    };

    const claimIdOfClosestNode = (path1, path2) => {
        path1.forEach((node, index) => {
            let closestNode = findClosestNode([node], path2);
            node.id = closestNode.node.id;
        });

        return path1;
    };

    // reorders the paths nodes starting with the index provided
    const reorderPath = (path, index) => {
        return [...path.slice(index), ...path.slice(0, index)];
    };

    // reverses the path, and shifts all curves to be in the right place
    const reversePath = path => {
        let newPath = path.reverse();
        let currentCurve = null;
        let lastCurve = null;

        newPath.forEach(point => {
            if (point?.curve) {
                currentCurve = point.curve;
                delete point.curve;
            }

            if (lastCurve) {
                point.curve = lastCurve;
                lastCurve = null;
            }

            lastCurve = currentCurve;
            currentCurve = null;
        });

        return newPath;
    };

    // takes two paths, and compares each point based on an id and returns the difference in distance
    const findDiffs = (path1, path2) => {
        return path1.map(point => {
            const point2 = path2.find(p => p.id === point.id);

            let xDiff = point?.x - point2?.x;
            let yDiff = point?.y - point2?.y;

            let pointDiff = {
                id: point.id,
                xDiff: xDiff.toFixed(6),
                yDiff: yDiff.toFixed(6),
                total: (Math.abs(xDiff) + Math.abs(yDiff)).toFixed(6)
            };

            return pointDiff;
        });
    };

    // inverts points on a path by whichever axis specified. used for flipping top box flaps to make them bottom box flaps, etc
    const invertPath = (path, axis, offset = 0) => {
        let lower = path[0]?.[axis] ?? 0;
        let upper = path[0]?.[axis] ?? 0;

        const invert = value => {
            return upper + (lower - value);
        };

        path.forEach((point, index) => {
            if (point?.[axis] < lower) {
                lower = point?.[axis];
            }
            if (point?.[axis] > upper) {
                upper = point?.[axis];
            }
        });

        const inverted = path.map(point => {
            point[axis] = invert(point[axis]) + offset;
            if (point?.curve?.control_end?.[axis]) {
                point.curve.control_end[axis] = invert(point.curve.control_end[axis]) + offset;
            }

            if (point?.curve?.control_start?.[axis]) {
                point.curve.control_start[axis] = invert(point.curve.control_start[axis]) + offset;
            }

            return point;
        });

        return inverted;
    };

    const pathFromDiff = (path, diffs) => {
        return path
            .map(point => {
                const diffPoint = diffs.find(p => p.id === point.id);

                if (diffPoint) {
                    point.x = point?.x - diffPoint?.xDiff;
                    point.y = point?.y - diffPoint?.yDiff;

                    // if (diffPoint?.curve) {
                    //     point.curve = diffPoint.curve;
                    //     point.type = diffPoint.type;
                    // }

                    return point;
                }
            })
            .filter(point => typeof point !== 'undefined');
    };

    return {
        buildPath,
        buildPathFromObj,
        claimIdOfClosestNode,
        findClosestNode,
        findDiffs,
        getAngle,
        innerBorder,
        invertPath,
        makePathAbsolute,
        objPathToArray,
        offsetPoint,
        offsetReversePoint,
        outerBorder,
        pathFromDiff,
        pathToObj,
        profilePath,
        reorderPath,
        repeatFirst,
        reversePath,
        Segment,
        segmentAngle,
        segmentLength
    };
};

export default svgTools;
